import { render, staticRenderFns } from "./VueCheckbox.vue?vue&type=template&id=584e23b8&"
import script from "./VueCheckbox.vue?vue&type=script&lang=js&"
export * from "./VueCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./VueCheckbox.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports